import React from 'react';
import * as FPT from '../utility/fpt';
import AppStore from '../stores/AppStore';
import TemplateData from '../utility/getTemplateData';
import { isExternalFlow } from '../utility/externalIntegrationUtils';
import { EVENT_NAME } from '../utility/constants';

const PAGE_TRACK_TAG = 'main:donate:wps:';

export default function withPageTrack(WrappedComponent, flow, result) {
  return class extends React.Component {
    componentDidMount() {
      const confData = AppStore.getConfirmation() || {};
      const isSignUp = confData.showAccountOverview || false;
      const trid = confData.confirmationNumber || '';

      if (isSignUp || TemplateData.fptPageName === 'guestULSignUp') {
        flow = 'signup';
      }

      let tag = `${PAGE_TRACK_TAG}${flow}:${result}`;
      const eventName = confData.isOfacPending
        ? EVENT_NAME.DW_GIVING_PAYMENT_PENDING_SCREEN_SHOWN
        : EVENT_NAME.DW_GIVING_PAYMENT_SUCCESS_SCREEN_SHOWN;

      if (isExternalFlow()) {
        FPT.trackPageWithData(tag, `${tag}:web::`, {
          trid,
          event_name: eventName,
          account_type: flow,
        });
      } else {
        FPT.trackPage(tag, `${tag}:web::`, 'trid', trid);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
